import { render, staticRenderFns } from "./AddYourTeamSvg.vue?vue&type=template&id=1f8c2054&scoped=true&"
import script from "./AddYourTeamSvg.vue?vue&type=script&lang=ts&"
export * from "./AddYourTeamSvg.vue?vue&type=script&lang=ts&"
import style0 from "./AddYourTeamSvg.vue?vue&type=style&index=0&id=1f8c2054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c2054",
  null
  
)

export default component.exports